import { useEffect, useRef, useState } from "react";

// 지문 낭독 음원(지인에듀가 지문마다 만들어 주는 mp3, 2026-10-16). '전체 본문' 머리줄 오른쪽에 둔다.
// 종이 시험지에서 QR 이 지문 오른쪽 위에 찍히는 것과 같은 자리다. 속도는 playbackRate 로만 바꾼다.
const SPEED_LIST = [0.8, 1, 1.2];
const PLAY_EVENT = "passage-audio-play";

// label: 버튼 글. 리더스북 듣기 쪽처럼 음원이 여럿이면 "듣기 1", "듣기 2" 로 가른다.
const PassageAudioButton = ({ audioUrl, accentColor = "#E8920A", label = "듣기" }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [speed, setSpeed] = useState(1);
  // 음원을 못 열면(지인에듀 이용권이 끝나면 404) 버튼을 조용히 숨긴다(2026-10-17 지인에듀 요청)
  const [isBroken, setIsBroken] = useState(false);

  useEffect(() => {
    setIsPlaying(false);
    setIsBroken(false);
    if (audioRef.current) audioRef.current.pause();
  }, [audioUrl]);

  useEffect(() => {
    if (audioRef.current) audioRef.current.playbackRate = speed;
  }, [speed]);

  // 한 화면에 음원이 여럿이면 하나만 울린다. 다른 버튼이 틀면 이것은 멈춘다.
  useEffect(() => {
    const pauseIfOther = (event) => {
      if (audioRef.current && event.detail !== audioRef.current) audioRef.current.pause();
    };
    window.addEventListener(PLAY_EVENT, pauseIfOther);
    // 쪽을 넘겨 버튼이 사라져도 떼어 낸 <audio> 는 계속 울릴 수 있어 멈추고 나간다.
    const audio = audioRef.current;
    return () => {
      window.removeEventListener(PLAY_EVENT, pauseIfOther);
      if (audio) audio.pause();
    };
  }, []);

  if (!audioUrl || isBroken) return null;

  const toggle = (event) => {
    event.stopPropagation();
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      audio.playbackRate = speed;
      audio.play().catch(() => setIsPlaying(false));
    } else {
      audio.pause();
    }
  };

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "4px", letterSpacing: 0 }}>
      <audio
        ref={audioRef}
        src={audioUrl}
        preload="none"
        onPlay={() => {
          setIsPlaying(true);
          window.dispatchEvent(new CustomEvent(PLAY_EVENT, { detail: audioRef.current }));
        }}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
        onError={() => setIsBroken(true)}
      />
      {SPEED_LIST.map((one) => (
        <button
          type="button"
          key={one}
          onClick={(event) => {
            event.stopPropagation();
            setSpeed(one);
          }}
          style={{
            border: "none",
            background: "transparent",
            padding: "2px 4px",
            fontFamily: "inherit",
            fontSize: "11px",
            fontWeight: 800,
            color: speed === one ? accentColor : "#B7C2C9",
            cursor: "pointer",
          }}
        >
          {one}x
        </button>
      ))}
      <button
        type="button"
        onClick={toggle}
        aria-label={isPlaying ? "멈춤" : label}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          height: "26px",
          padding: "0 10px",
          border: "none",
          borderRadius: "999px",
          background: isPlaying ? accentColor : "#0E141B",
          color: "#FFFFFF",
          fontFamily: "inherit",
          fontSize: "12px",
          fontWeight: 800,
          cursor: "pointer",
        }}
      >
        {isPlaying ? "❚❚ 멈춤" : `▶ ${label}`}
      </button>
    </span>
  );
};

export default PassageAudioButton;
